import { motion } from 'motion/react'
import { ChevronDown } from 'lucide-react'
import { type FC } from 'react'

interface AnimatedChevronProps {
  isOpen: boolean
  size?: number
  className?: string
}

const AnimatedChevron: FC<AnimatedChevronProps> = ({
  isOpen,
  size = 14,
  className = 'text-pearl/55',
}) => (
  <motion.span
    className={`inline-flex ${className}`}
    animate={{ rotate: isOpen ? 180 : 0 }}
    transition={{ duration: 0.2 }}
  >
    <ChevronDown size={size} />
  </motion.span>
)

export default AnimatedChevron
